import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['chunked', 'full', 'normalDescription', 'checkpointDescription'];
  static values = { initial: String };

  connect() {
    // Scope by the persisted model field rather than relying on target
    // registration order or matching another radio group in this form.
    const checked = this.element.querySelector(
      'input[name="author_document[reading_mode]"]:checked',
    );
    const mode = checked?.value || this.initialValue;
    if (mode) {
      this.toggle(mode);
    }
  }

  select(event) {
    this.toggle(event.target.value);
  }

  toggle(value) {
    if (this.hasChunkedTarget) {
      this.chunkedTarget.classList.toggle('hidden', value !== 'checkpointed');
    }
    if (this.hasNormalDescriptionTarget) {
      this.normalDescriptionTarget.classList.toggle('hidden', value === 'checkpointed');
    }
    if (this.hasCheckpointDescriptionTarget) {
      this.checkpointDescriptionTarget.classList.toggle('hidden', value !== 'checkpointed');
    }
  }
}
